import { useEffect, useState } from "react";
import Block from "./components/block";
import { BLOCK_DEFAULT } from "../../constants/constants";
import { generateUUID, getButtonActionId, getTemporaryBlockId } from "../../../../../../services/helpers/Helper";

const Navigation = (props) => {
   const {
      faq,
      data,
      onChange,
      onSelectFaq,
   } = props;
   const { first_block: firstBlock, blocks, answer } = data;

   const [listIdUsed, setListIdUsed] = useState([]);

   const onChangeAnswerContent = (string) => {
      if (onChange) {
         onChange({ ...data, answer: string });
      }
   }

   const handleAddBlock = () => {
      if (onChange) {
         onChange({ ...data, blocks: [...blocks, { ...BLOCK_DEFAULT, temporary_block_id: generateUUID() }] });
      }
   }

   const onChangeBlockTitle = (id, string) => {
      if (onChange) {
         let newData = data;
         if (firstBlock.id === id) {
            newData.first_block.title = string;
         }
         newData.blocks = blocks.map(m => {
            if (getTemporaryBlockId(m) === id) {
               m.title = string;
            }
            return m;
         });
         onChange(newData);
      }
   }

   const onCopyBlock = (block) => {
      //fix lỗi http://jira.mocha.com.vn/browse/PTPM-14214
      // copy thành data mới tránh trùng bộ nhớ đệm
      const blockNew = { ...block }
      if (onChange) {
         delete blockNew.id;
         onChange({ ...data, blocks: [...blocks, { ...blockNew, temporary_block_id: generateUUID() }] });
      }
   }

   const onDeleteBlock = (id) => {
      if (onChange) {
         onChange({ ...data, blocks: blocks.filter(f => getTemporaryBlockId(f) !== id) });
      }
   }

   const onProcessUsed = () => {
      let list = []
      blocks.forEach(block => {
         block?.cards?.forEach(card => {

            card?.buttons?.forEach(button => {
               if (button?.action?.type === 'block' && getButtonActionId(button.action)) {
                  list.push(getButtonActionId(button.action))
               }
            })
         })
      });
      firstBlock?.cards?.forEach(card => {
         switch (card.type) {
            case 'text':
               card?.buttons?.forEach(button => {
                  if (button?.action?.type === 'block' && getButtonActionId(button.action)) {
                     list.push(getButtonActionId(button.action))
                  }
               })
               break;
            case 'gallery':
               card?.images?.forEach(image => {
                  image?.buttons?.forEach(button => {
                     if (button?.action?.type === 'block' && getButtonActionId(button.action)) {
                        list.push(getButtonActionId(button.action))
                     }
                  })
               })
               break
            default:
               card?.buttons?.forEach(button => {
                  if (button?.action?.type === 'block' && getButtonActionId(button.action)) {
                     list.push(getButtonActionId(button.action))
                  }
               })
               break;
         }
      });
      setListIdUsed([...new Set(list)]);
   }

   const getListBlockUsed = () => {
      return blocks.filter(block => listIdUsed.includes(getTemporaryBlockId(block)) && !block.is_hidden);
   }

   const getListBlockUnused = () => {
      return blocks.filter(block => !listIdUsed.includes(getTemporaryBlockId(block)) && !block.is_hidden);
   }

   const isSelected = (block) => {
      return (block && faq) ? (faq.id ? faq.id === block.id : (faq.temporary_block_id ? faq.temporary_block_id === block.temporary_block_id : false)) : false
   }

   useEffect(onProcessUsed, [blocks]);

   return (
      <div className="blocks-navigation col-auto">
         <div className="message-flow-name-wrapper">
            <div className="text-muted label">Nội dung câu trả lời</div>
            <div className="message-flow-name-input">
               <div className="input-text input-text-none-scrollbar text-single font-size-14 form-control">
                  <input type="text" value={answer} onChange={(e) => onChangeAnswerContent(e.target.value)} readOnly={!onChange} />
               </div>
            </div>
         </div>
         <div>
            <div className="text-muted">Bắt đầu</div>
            <div>
               <div className="blocks-navigation-item" >
                  {firstBlock &&
                     <Block
                        block={firstBlock}
                        isSelected={isSelected(firstBlock)}
                        onChangeBlockTitle={onChangeBlockTitle}
                        onCopyBlock={onCopyBlock}
                        onSelectFaq={onSelectFaq}
                     />
                  }
               </div>
            </div>
            <div className="text-muted">Đang sử dụng</div>
            <div>
               <div className="blocks-navigation-item">
                  {getListBlockUsed().map((block, index) => (
                     <Block
                        block={block}
                        isSelected={isSelected(block)}
                        key={index}
                        onChangeBlockTitle={onChangeBlockTitle}
                        onCopyBlock={onCopyBlock}
                        onDeleteBlock={onDeleteBlock}
                        onSelectFaq={onSelectFaq}
                     />
                  ))}
               </div>
            </div>
            <div className="text-muted">Chưa sử dụng</div>
            <div>
               <div className="blocks-navigation-item">
                  {getListBlockUnused().map((block, index) => (
                     <Block
                        block={block}
                        isSelected={isSelected(block)}
                        key={index}
                        onChangeBlockTitle={onChangeBlockTitle}
                        onCopyBlock={onCopyBlock}
                        onDeleteBlock={onDeleteBlock}
                        onSelectFaq={onSelectFaq}
                     />
                  ))}
               </div>
            </div>
            <div>
               <div className="blocks-navigation-item-add-new text-center mb8" onClick={handleAddBlock}>
                  <span>+ Thêm nội dung mới</span>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Navigation;